import { call, put, takeLatest, all } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";
import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

// Redux States
import {
  INFO_PROFILE_FETCH_REQUEST,
  INFO_PROFILE_FETCH_SUCCESS,
  INFO_PROFILE_FETCH_FAILURE,
} from "./actionTypes";


function* fetchInfoProfileSaga(action) {

  try {

    const [profileResponse, topicResponse, postsResponse] = yield all([
      call(axiosInstance.get, `/knovia/myInfo/userInfoProfile`),
      call(axiosInstance.get, `/knovia/myInfo/userInfoTopics`),
      call(axiosInstance.get, `/knovia/myInfo/userInfoPosts`)
    ]);

    const profile = profileResponse.data;
    const topics = topicResponse.data;
    const posts = postsResponse.data;

    // trigger fetch images
    const filenames = new Set();

    if (profile?.backgroundImage) filenames.add(profile.backgroundImage);
    if (profile?.profileImage) filenames.add(profile.profileImage);

    topics.forEach(t => {
      if (t.image) filenames.add(t.image);
    });

    posts.forEach(p => {
      if (p.profileImage) filenames.add(p.profileImage);
      if (Array.isArray(p.images)) {
        p.images.forEach(img => img && filenames.add(img));
      }
    });

    yield put({
      type: FETCH_MISSING_IMAGES,
      payload: { filenames: [...filenames] }
    });

    yield put({
      type: INFO_PROFILE_FETCH_SUCCESS,
      payload: { profile, topics, posts }
    });

  } catch (err) {
    console.error('[fetchInfoProfileSaga] Error:', err);
    yield put({
      type: 'INFO_PROFILE_FETCH_FAILURE',
      payload: err.message || 'Fetch failed'
    });
  }
}

function* infoProfileSaga() {
  yield takeLatest(INFO_PROFILE_FETCH_REQUEST, fetchInfoProfileSaga);
}

export default infoProfileSaga;


